import { LmIconFilledMiscSchool, LmIconOutlineMiscSchool } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconProfessionEducationCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineMiscSchool {...rest} /> : <LmIconFilledMiscSchool {...rest} />;

export default IconProfessionEducationCommon;
